export default __webpack_public_path__ + "static/media/pngcellpic.68fb99ae.png";